module.exports = __webpack_public_path__ + "static/diaconia_395x344-8ca6e55b084e093aa5b574be9cc9c815.png";